import {DestructableView} from "./DestructableView";
import EstablishmentRepository from "../repositories/EstablishmentsRepository";
import Establishment from "../class/accounting/Establishment";
import {VueClass, VueMounted, VueVar} from "horizon-js-front-sdk/lib/VueAnnotate";
import {Autowire} from "horizon-js-front-sdk/lib/DependencyInjector";

@VueClass()
export default class NavbarView extends DestructableView {
	@VueVar() currentEstablishment: Establishment | null = null;
	@VueVar() openMobileMenu: boolean = false;
	@VueVar() getPathNameWithEstablishmentUid: any = EstablishmentRepository.getPathNameWithEstablishmentUid;

	/** Repository **/
	@Autowire(EstablishmentRepository) establishmentRepository!: EstablishmentRepository;

	constructor(container: string, vueDataConstructor: any = null) {
		super(vueDataConstructor);
	}

	@VueMounted()
	mounted() {
		this.establishmentRepository.getAll().then((establishments: Establishment[]) => {
			this.establishmentRepository.get_current_establishment_uid().then((uuid: Uuid) => {
				for (let establishment of establishments) {
					if (establishment.uid === uuid) {
						this.currentEstablishment = establishment;
					}
				}
			});
		});
	}
}